/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * This file is part of Recharts Project which is released under MIT license.
 * See file https://github.com/recharts/recharts/blob/master/src/util/ReactUtils.ts or go to https://opensource.org/licenses/MIT for full license details.
 */

import React from 'react';

/**
 * Get the display name of a component
 * @param  {Object} Component Specified Component
 * @return {String}      Display name of Component
 */
export const getDisplayName = (Component) => {
    if (typeof Component === 'string') {
        return Component;
    }
    if (!Component) {
        return '';
    }
    return Component.displayName || Component.name || 'Component';
};

/*
 * Find and return all matched children by type. `type` can be a React element class or
 * string
 */
export const findAllByType = (children, type) => {
    const result = [];
    let types = [];

    if (Array.isArray(type)) {
        types = type.map((t) => getDisplayName(t));
    } else {
        types = [getDisplayName(type)];
    }

    React.Children.forEach(children, (child) => {
        const childType = child && child.type && (child.type.displayName || child.type.name);
        if (types.indexOf(childType) !== -1) {
            result.push(child);
        }
    });

    return result;
};
/*

 * Return the first matched child by type, return null otherwise.
 * `type` can be a React element class or string.
 */
export const findChildByType = (children, type) => {
    const result = findAllByType(children, type);

    return result && result[0];
};

/*
 * check component type and return boolean .
 * `type` can be a React element class or string.
 */
export const childIsType = (component, type) => {
    let types = [];

    if (Array.isArray(type)) {
        types = type.map((t) => getDisplayName(t));
    } else {
        types = [getDisplayName(type)];
    }

    const childType = component && component.type && (component.type.displayName || component.type.name);
    return types.indexOf(childType) !== -1;
};
